import {
  createContext,
  useContext,
  type CSSProperties,
  type ReactNode,
} from "react";

// Shortcut input must stay above onboarding (32000), with the OS tray (32100)
// still reachable. Its body-portalled menus share the same surface tier.
const SUMMONED_INPUT_Z_INDEX = 32050;
const SUMMONED_INPUT_MENU_STYLE: CSSProperties = { zIndex: 32060 };
const SummonedInputSurfaceContext = createContext(false);

function SummonedInputSurfaceScope({ children }: { children: ReactNode }) {
  return (
    <SummonedInputSurfaceContext.Provider value={true}>
      {children}
    </SummonedInputSurfaceContext.Provider>
  );
}

function useSummonedInputMenuStyle(): CSSProperties | undefined {
  return useContext(SummonedInputSurfaceContext)
    ? SUMMONED_INPUT_MENU_STYLE
    : undefined;
}

/* eslint-disable react-refresh/only-export-components */
export {
  SUMMONED_INPUT_Z_INDEX,
  SummonedInputSurfaceScope,
  useSummonedInputMenuStyle,
};
/* eslint-enable react-refresh/only-export-components */
